import React, {Component} from 'react';
import {AGENT_API_URL, COMPANY_API_URL} from "../../../constants/api_routes";
import {Button, Divider, Form, Grid, Header, Icon, Label, Popup, Segment} from "semantic-ui-react";
import ListingContainer from "../../../containers/listing_container";
import {getListingData} from "../../../data/user_api";
import validatePasswordStrength from "../../../utils/password_validation";
import CreateCompany from "../../company/create_company";

class CreateAgentUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyListing: [],
            assignedCompanyId: undefined,
            pswdLength:false,
            pswdLC:false,
            pswdUC:false,
            pswdSym:false,
            pswdNum:false,
            isCompanyAssigned: true,
            showAgent:true
        }
    }

    componentDidMount() {
        this.getCompanyList().then();
        if(this.props.companyId){
            this.setState({assignedCompanyId:this.props.companyId})
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if(this.state.assignedCompanyId){
            formData.append("company_id",this.state.assignedCompanyId);
        }
        else {
            this.setState({isCompanyAssigned:false});
            return;
        }
        this.setState({disableSave:true});
        this.props.create(AGENT_API_URL, formData, this.handleCreateResponse,this.props.companyId);

    };

    handleCreateResponse = (response) => {
        if (response.success) {
            this.props.onSuccess();
        }
    };

    getCompanyList = async () => {
        const companyOptions = await getListingData(COMPANY_API_URL);
        let newObj = [];
        for (let i = 0; i < companyOptions.length; i++) {
            let obj = {
                key: companyOptions[i].id,
                text: companyOptions[i].name,
                value: companyOptions[i].id
            };
            newObj.push(obj);
        }

        this.setState({companyListing: newObj});
    };

    validatePassword = (password) => {
        this.setState({
            pswdLength:validatePasswordStrength.charLength(password),
            pswdLC:validatePasswordStrength.lowercase(password),
            pswdUC:validatePasswordStrength.uppercase(password),
            pswdSym:validatePasswordStrength.special(password),
            pswdNum:validatePasswordStrength.hasNumber(password),
        });
    };


    render() {
        return (
            <div>
            {this.state.showAgent ? <div>
                <Header as='h2' textAlign='center'>
                    Create New Agent
                </Header>
                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Profile Details
                                </Label>
                                <p></p>

                                <div>
                                    <div className="pull-left" style={{width:'85%'}}>
                                        <Form.Dropdown
                                            label='Company'
                                            search
                                            noResultsMessage="Company not found"
                                            selection
                                            required
                                            wrapSelection={false}
                                            error={!this.state.isCompanyAssigned}
                                            options={this.state.companyListing}
                                            placeholder='company'
                                            onFocus={()=>this.setState({isCompanyAssigned:true})}
                                            defaultValue={this.props.companyId?this.props.companyId:undefined}
                                            onChange={(e, option) => {
                                                this.setState({assignedCompanyId: option.value})
                                            }}
                                        />
                                    </div>
                                    <div style={{marginTop:'7%',paddingBottom:'5%'}} className="pad-left pull-left icon-button" onClick={()=>{this.setState({showAgent:false})}}>
                                        <Icon name='building outline' size="large" />
                                    </div>
                                </div>

                                <Form.Input label='Name'
                                            fluid
                                            icon='user'
                                            iconPosition='left'
                                            placeholder='Name'
                                            type='text'
                                            name="name"
                                            required
                                />
                                <Form.Input label='Email'
                                            fluid
                                            icon='mail'
                                            iconPosition='left'
                                            placeholder='E-mail address'
                                            name="user[email]"
                                            required
                                />
                                <Popup trigger={
                                    <Form.Input label='Password' fluid icon='lock' iconPosition='left'
                                                placeholder='Password'
                                                type='password' name="user[password]" pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?=.*\d).{6,}"
                                                onChange={(e) => {this.validatePassword(e.target.value)}}
                                                required/>}
                                       content={<Segment>
                                           <p className={this.state.pswdLength?"info-success":"info-negative"}>Password must be 6 chars or more</p>
                                           <p className={this.state.pswdLC?"info-success":"info-negative"}>Must have atleast 1 lowercase</p>
                                           <p className={this.state.pswdUC?"info-success":"info-negative"}>Must have atleast 1 uppercase</p>
                                           <p className={this.state.pswdSym?"info-success":"info-negative"}>Must have atleast 1 special character</p>
                                           <p className={this.state.pswdNum?"info-success":"info-negative"}>Must have atleast 1 Number</p>
                                       </Segment>}
                                       on="focus"
                                       position="right center"
                                       wide
                                       hideOnScroll
                                />
                                <Form.Input label='Mobile Number'
                                            fluid
                                            icon='mobile'
                                            iconPosition='left'
                                            placeholder='328659286'
                                            type='text'
                                            name="mobile_number"
                                            required
                                />
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Address Details
                                </Label>
                                <p></p>
                                <Form.Input fluid
                                            label='Address Line 1'
                                            placeholder='Street'
                                            type='text'
                                            name="line1"
                                            required/>
                                <Form.Input fluid
                                            label='Address Line 2'
                                            placeholder='Landmark'
                                            type='text'
                                            name="line2"
                                />
                                <Form.Group widths={2}>
                                    <Form.Input fluid
                                                label='Region'
                                                placeholder='Region'
                                                type='text'
                                                name="locality"
                                    />
                                    <Form.Input fluid
                                                label='City'
                                                placeholder='City'
                                                type='text'
                                                name="city"
                                    />
                                </Form.Group>
                                <Form.Input fluid
                                            label='Country'
                                            placeholder='Country'
                                            type='text'
                                            name="country"
                                />
                                <Form.Input fluid
                                            label='Postcode'
                                            placeholder='C2PN57'
                                            type='text'
                                            name="postcode"
                                            required
                                />
                            </Segment>
                        </Grid.Column>
                        <div className="center-aligned submit-buttons">
                            {this.props.cancel && <Button content="Cancel" type="button" onClick={(e)=>{e.preventDefault();this.props.close()}}/>}
                            <Button primary disabled={this.state.disableSave}>Create Agent</Button>
                        </div>
                    </Grid>
                </Form>
            </div>: <CreateCompany close={()=>{this.getCompanyList().then(()=>this.setState({showAgent:true}))}} cancel={true}/>}
            </div>
        );
    }

}

export default ListingContainer(CreateAgentUser);


// WEBPACK FOOTER //
// ./src/views/user/agent/create_user.js